import Vue from 'vue'
import Vuex from 'vuex'
import modules from './modules'
import authApi from '@/api/auth'

Vue.use(Vuex)

const store = new Vuex.Store({
  state: {
    authUser: null
  },
  getters: {
    authenticated: state => state.authUser !== null,
    accessToken: state =>
      state.authUser !== null ? state.authUser.access_token : null,

    limitStringShow: state => (text, limit = 50) => {
      if (text != null) {
        let article = text.replace(/(<([^>]+)>)/gi, '')
        return article.length > limit
          ? article.substring(0, limit) + '...'
          : article
      }
      return ''
    }
  },
  mutations: {
    DRAWER_STATE(state, value) {
      state.drawer.model = value
    },
    MINI_DRAWER(state) {
      state.drawer.mini = !state.drawer.mini
    },
    setAuthUser(state, authUser) {
      if (authUser) {
        state.authUser = Object.assign(
          {},
          {
            user_name: authUser.user_name,
            // token_type: authUser.token_type,
            // refresh_token: authUser.refresh_token,
            // expires_in: authUser.expires_in,
            access_token: authUser.access_token
          }
        )

        localStorage.setItem('authUser', JSON.stringify(state.authUser))
      } else {
        state.authUser = null
        localStorage.clear()
      }
    }
  },
  actions: {
    init({ commit }) {
      const authUser = JSON.parse(localStorage.getItem('authUser'))

      if (authUser) {
        commit('setAuthUser', authUser)
      }
    },
    login({ commit }, formData) {
      return authApi.login(formData).then(response => {
        commit('setAuthUser', response.data)

        return Promise.resolve(response)
      })
    },
    logout({ commit }) {
      commit('setAuthUser', null)
    }
  },
  modules
})

store.dispatch('init')

export default store
